export const REQUEST_MEDIA_PERPETRATORS = "media/REQUEST_MEDIA_PERPETRATORS";
export const REQUEST_MEDIA_PERPETRATORS_SUCCESS =
  "media/REQUEST_MEDIA_PERPETRATORS_SUCCESS";
export const REQUEST_MEDIA_PERPETRATORS_FAIL =
  "media/REQUEST_MEDIA_PERPETRATORS_FAIL";

export const REQUEST_MEDIA_PERPETRATORS_ITEM =
  "media/REQUEST_MEDIA_PERPETRATORS_ITEM";
export const REQUEST_MEDIA_PERPETRATORS_ITEM_SUCCESS =
  "media/REQUEST_MEDIA_PERPETRATORS_ITEM_SUCCESS";
export const REQUEST_MEDIA_PERPETRATORS_ITEM_FAIL =
  "media/REQUEST_MEDIA_PERPETRATORS_ITEM_FAIL";

export const REQUEST_ADD_MEDIA_PERPETRATORS =
  "media/REQUEST_ADD_MEDIA_PERPETRATORS";
export const REQUEST_ADD_MEDIA_PERPETRATORS_SUCCESS =
  "media/REQUEST_ADD_MEDIA_PERPETRATORS_SUCCESS";
export const REQUEST_ADD_MEDIA_PERPETRATORS_FAIL =
  "media/REQUEST_ADD_MEDIA_PERPETRATORS_FAIL";

export const REQUEST_DEL_MEDIA_PERPETRATORS =
  "media/REQUEST_DEL_MEDIA_PERPETRATORS";
export const REQUEST_DEL_MEDIA_PERPETRATORS_SUCCESS =
  "media/REQUEST_DEL_MEDIA_PERPETRATORS_SUCCESS";
export const REQUEST_DEL_MEDIA_PERPETRATORS_FAIL =
  "media/REQUEST_DEL_MEDIA_PERPETRATORS_FAIL";

export const RESET_MEDIA_PERPETRATORS_UPLOADS =
  "media/RESET_MEDIA_PERPETRATORS_UPLOADS";
export const UPDATE_MEDIA_PERPETRATORS_PROGRESS =
  "media/UPDATE_MEDIA_PERPETRATORS_PROGRESS";

export const CLEAR_MEDIA_PERPETRATORS_ERROR =
  "media/CLEAR_MEDIA_PERPETRATORS_ERROR";
